import { Toast } from 'bootstrap';
import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import { MessageCircle, Check } from 'lucide-react';
import { useSelector, useDispatch } from 'react-redux';
import { loginUser, VerifyUserOtp, logout } from '../../redux/auth/auth';
import { cleanObject } from '../../components/cleanObject';
import { useNavigate } from "react-router-dom";
import { APP_URL } from '../../config/constants.config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/free-solid-svg-icons';
function Login() {
    // const count = useSelector(state => state.auth.value);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showOtp, setShowOtp] = useState(true);
    const [hasLogin, setHasLogin] = useState({
        countryCode: "+91",
        mobile: "",
        otp: "",
        otpVia: "text",
        referredBy: "",
        loginVia: "clientWeb"
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        const cleanValue = (name === "mobile" || name === "otp") ? value.replace(/\D/g, '') : value;
        setHasLogin(prev => ({
            ...prev,
            [name]: cleanValue
        }));
    };

    const handleSendOtp = async (e) => {
        // e.preventDefault();
        if (hasLogin.mobile.length === 10) {
            const cleanedPayload = cleanObject(hasLogin);
            const { otp, ...rest } = cleanedPayload
            const response = await dispatch(loginUser(rest));
            if (loginUser.fulfilled.match(response)) {
                toast.success(response?.payload?.message)
                setShowOtp(false);
            }
        } else {
            toast.error("Please enter a valid 10-digit mobile number.");
        }
    };

    const handleVerifyOtp = async (e) => {
        if (hasLogin.otp.length === 4) {
            const cleanedPayload = cleanObject(hasLogin);
            const { otpVia, loginVia, ...rest } = cleanedPayload
            const response = await dispatch(VerifyUserOtp({ ...rest, isWealth: true, }));
            if (VerifyUserOtp.fulfilled.match(response)) {
                // if (response?.payload?.data?.wealthInvestmentAmt && response?.payload?.data?.multibaggerAllocation) {
                //     navigate("/dashboard");
                // } else {
                //     navigate("/portfolio");
                // }
                navigate("/dashboard");
                toast.success(response?.payload?.message)
                setHasLogin({
                    countryCode: "+91",
                    mobile: "",
                    otp: "",
                    otpVia: "text",
                    referredBy: "",
                    loginVia: "clientWeb"
                });
                setShowOtp(true);
            } else {
                toast.error(response.payload.message)
            }
        } else {

            alert("Please enter a valid 4-digit OTP.");
        }
    };
    const [timer, setTimer] = useState(30);

    useEffect(() => {
        if (timer <= 0 || showOtp) return;

        const countdown = setInterval(() => {
            setTimer(prev => prev - 1);
        }, 1000);

        return () => clearInterval(countdown); // cleanup on unmount or dependency change
    }, [timer, showOtp]);

    return (
        <div className="container-fluid p-0 text-body-emphasis" style={{ minHeight: '100vh' }}>
            <div className="row w-100 m-0 p-md-4 p-4 p" style={{
                minHeight: '100vh',
                backgroundImage: "url('/assets/img/Background.png')",
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                color: '#fff',
                // padding: '3rem',
            }}>
                {/* Left Side */}
                <div
                    className="col-lg-8 col-md-8 col-12 mx-auto d-md-flex flex-column  justify-content-center"
                >
                    <h1 className='fw-bold  text-center text-lg-start fst-italic display-5' style={{ cursor: "pointer" }} onClick={() => navigate("/")}>WealthX</h1>
                    <div style={{ marginTop: 'auto' }}>
                        <h2 className='fw-bolder  text-center text-lg-start d-none d-lg-block display-4 text-capitalize '>Let's begin your journey towards exponential wealth</h2>
                        <h3 className="fw-bold  text-center text-lg-start display-6 d-lg-none text-start mt-4">Let's begin your journey towards exponential wealth</h3>
                        {/* For md and larger */}
                        <p className="d-none d-lg-block" style={{ marginTop: '1rem', fontSize: '0.85rem', color: '#ccc' }}>
                            © Copyright {new Date().getFullYear()} Equitypandit Financial Services Private Limited. All Rights Reserved
                        </p>
                    </div>
                </div>

                {/* Right Side */}

                <div
                    className="col-lg-4 col-md-6  col-12 mx-auto d-flex align-items-center justify-content-center p-md-4 p-1 flex-column rounded-5"
                    style={{
                        // height: '100vh',
                        background: "#000319"
                    }}
                >
                    <div
                        style={{
                            maxWidth: '700px',
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            padding: '1.5rem',
                            borderRadius: '10px',
                            width: '100%',
                        }}
                    >
                        <h2 className="text-white" style={{ fontWeight: '700' }}>Hi, Welcome! 👋</h2>
                        <h4 className="mt-3 text-white" style={{ fontWeight: '400' }}>Let's get started</h4>
                        {showOtp ? (
                            <form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    handleSendOtp();
                                }}
                            >
                                <div className="mb-3 mt-md-5 mt-1">
                                    <label className="text-muted form-label  mt-3">
                                        Enter Your Mobile Number
                                    </label>
                                    <input
                                        type="text"
                                        name="mobile"
                                        id="mobile"
                                        maxLength={10}
                                        inputMode="numeric"
                                        required
                                        value={hasLogin.mobile}
                                        onChange={handleChange}
                                        className="form-control mt-2"
                                        // placeholder="Enter Mobile Number"
                                        // style={{ height: '45px' }}
                                        style={{ height: '45px', fontSize: '18px' }}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label className="text-white form-label ">Get OTP On</label>
                                    <div className="d-flex gap-2 mt-2">
                                        <button
                                            type="submit"
                                            className="btn  w-50"
                                            style={{
                                                height: '45px',
                                                background: 'linear-gradient(to right, #C609FA, #3959FE, #0E9EEE)',
                                                color: 'white',
                                                height: '45px',
                                                border: 'none',
                                            }}
                                            onClick={() => setHasLogin({ ...hasLogin, otpVia: "text" })}
                                        >
                                            <span
                                                className="gap-1"
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                <MessageCircle size={16} />
                                                <span>SMS</span>
                                            </span>
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn btn-outline-light w-50"
                                            style={{ height: '45px' }}
                                        >
                                            <span
                                                className="gap-1"
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                                onClick={() => setHasLogin({ ...hasLogin, otpVia: "whatsapp" })}
                                            >
                                                <MessageCircle size={16} />
                                                <span>Whatsapp</span>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        ) :
                            <form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    handleVerifyOtp();
                                }}
                            >
                                <div className="mb-3 mt-5">
                                    <label className="text-white form-label  fw-bold mt-3 d-flex justify-content-center">
                                        A 4 digit OTP has been sent to{" "}
                                        {hasLogin.mobile?.slice(0, 2) +
                                            "*".repeat(hasLogin.mobile.length - 4) +
                                            hasLogin.mobile.slice(-2)}
                                        <FontAwesomeIcon icon={faPencil} className="border ms-2 p-1 rounded" onClick={() => {
                                            setShowOtp(true)
                                            setTimer(30)
                                        }} />
                                    </label>
                                    <input
                                        type="text"
                                        name="otp"
                                        id="otp"
                                        maxLength={4}
                                        inputMode="numeric"
                                        required
                                        value={hasLogin.otp}
                                        onChange={handleChange}
                                        className="form-control mt-2"
                                        placeholder="Enter OTP"
                                        style={{ height: "45px" }}
                                    />
                                </div>
                                <div className="text-muted mt-2">

                                    <>
                                        <div className='d-flex justify-content-between'>
                                            <span className="text-light">
                                                {timer > 0 && `00:${timer.toString().padStart(2, "0")}`}
                                            </span>
                                            {/* <label className={`form-label text-${timer > 0 ? "muted" : "light"}`}
                                                onClick={() => {

                                                    if (timer <= 0) {
                                                        setTimer(30)
                                                        handleSendOtp()
                                                    }
                                                }}
                                                style={{ cursor: "pointer" }}
                                            >Resend OTP</label> */}
                                            {timer <= 0 && <a
                                                role="button"
                                                className={`text-${timer > 0 ? "muted" : "light"}`}
                                                onClick={(e) => {
                                                    e.preventDefault(); // Prevent page jump
                                                    if (timer <= 0) {
                                                        setTimer(30);
                                                        handleSendOtp();
                                                    }
                                                }}
                                                style={{
                                                    cursor: timer <= 0 ? "pointer" : "not-allowed",
                                                    textDecoration: "underline",
                                                }}
                                            >
                                                Resend OTP
                                            </a>}
                                        </div>
                                    </>
                                </div>
                                <div className="mb-3">

                                    <div className="mt-2">
                                        <button
                                            type="submit"
                                            className="btn btn-primary w-100"
                                            style={{
                                                height: '45px', background: 'linear-gradient(to right, #C609FA, #3959FE, #0E9EEE)',
                                                color: 'white',
                                                height: '45px',
                                                border: 'none',
                                            }}
                                        >
                                            <span
                                                className="gap-1"
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <span>Verify OTP</span>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        }


                        {/* <div style={{ marginTop: 'auto' }}>
                            <p style={{ fontSize: '0.8rem', color: '#6c757d' }}>
                                This site is protected by reCAPTCHA and the Google
                                <a
                                    href="https://policies.google.com/privacy"
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{ color: '#0d6efd', margin: '0 4px' }}
                                >
                                    Privacy Policy
                                </a>
                                and
                                <a
                                    href="https://policies.google.com/terms"
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{ color: '#0d6efd', margin: '0 4px' }}
                                >
                                    Terms of Service
                                </a>
                                apply. A Platform by{' '}
                                <a href="#" style={{ color: '#0d6efd' }}>
                                    EquityPandit Financial Services Private Limited.
                                </a>
                            </p>
                        </div> */}
                    </div>
                </div>

                <p className="d-lg-none mt-3" style={{ marginTop: '1rem', fontSize: '0.85rem', color: '#ccc' }}>
                    © Copyright {new Date().getFullYear()} Equitypandit Financial Services Private Limited. All Rights Reserved
                </p>
            </div>
        </div >
    );
}

export default Login;
